import { render } from "./MainProductChatbot.vue?vue&type=template&id=dc4b87a8&scoped=true"
import script from "./MainProductChatbot.vue?vue&type=script&lang=js"
export * from "./MainProductChatbot.vue?vue&type=script&lang=js"

import "./MainProductChatbot.vue?vue&type=style&index=0&id=dc4b87a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4b87a8"]])

export default __exports__